// i18n area 'vms' — locale de-DE (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.de-DE.meta.json.
import type { enUS } from './vms'

export const deDE: typeof enUS = {
  vms: {
    spof: {
      title: 'Unabhängigkeit vom Knoten',
      single: 'Einzelner Ausfallpunkt',
      alternativesNow: 'Alternativen jetzt',
      structural: 'Konstruktionsbedingt',
      binding: 'Bindende Einschränkung',
      movableNow: 'Jetzt migrierbar',
    },
    title: 'Virtuelle Maschinen',
    migratingChip: 'Migration läuft',
    templateChip: 'Template',
    expendableTooltip: 'In einem degradierten Cluster gehört sie zu den ersten, die gestoppt werden, und startet nach einem Knotenverlust möglicherweise nicht neu.',
    expendableHaTooltip: 'Solange der Cluster gesund ist, wird sie immer neu gestartet; in einem degradierten Cluster kommen geschützte VMs zuerst — sie kann gestoppt werden oder aus bleiben, bis der Cluster wieder vollständig ist, dann kehrt sie von selbst zurück.',
    viewDetails: 'Details ansehen',
    profileLegacy: 'Anderes OS',
    hugePagesNone: 'Keine — normaler Speicher',
    hugePages2M: '2-MiB-Seiten',
    hugePages1G: '1-GiB-Seiten',
    searchPlaceholder: 'Nach Name suchen',
    name: 'Name',
    vcpus: 'vCPU',
    memory: 'Arbeitsspeicher',
    ipAddresses: 'IP-Adressen',
    noIp: 'Keine IP',
    authorityNode: 'Authority',
    authorityNextStart: 'wird beim nächsten Start zugewiesen',
    scope: 'Scope',
    empty: 'Keine virtuellen Maschinen',
    loadError: 'Die virtuellen Maschinen konnten nicht geladen werden — ist das TVirt-Backend erreichbar?',
    filterOverlay: 'Overlay-Netzwerk',
    filterDisk: 'Festplatte',
    filterImage: 'Image',
    filteredBy: 'Gefiltert nach {kind}',
    filterPhase: 'Phase',
    filterProtection: 'Schutz',
    filterAll: 'Alle',
    filterScopePlaceholder: 'Nach Scope filtern',
    filtersToggle: 'Filter',
    scopeTree: {
      title: 'Scopes',
      all: 'Ganzer Cluster',
      noChildren: 'Keine Unter-Scopes hier',
      recursive: 'Nachkommen einschließen',
      collapse: 'Scope-Panel einklappen',
      up: 'Eine Ebene hoch',
      countTooltip: '{direct} VMs in diesem Scope · {total} mit Nachkommen'
    },
    isoPicker: {
      catalog: 'Katalog',
      unknownCatalog: 'Außerhalb der sichtbaren Kataloge',
      noIsos: 'Kein bereites ISO-Image in diesem Katalog'
    },
    actionsHeader: 'Aktionen',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Hardware',
      tags: 'Tags',
      age: 'Alter',
      disk: 'Festplatte',
      disks: 'Festplatten',
      empty: 'Noch kein Template — markieren Sie eine ausgeschaltete VM als Template, oder klonen Sie eine VM als Template.',
      clone: 'Klonen / Deploy',
      editTags: 'Tags bearbeiten',
      exportAction: 'In den Katalog exportieren (.tvtpl)',
      exportTitle: 'In den Katalog exportieren',
      exportSubmit: 'Exportieren',
      exportError: 'Export fehlgeschlagen',
      exportHint: 'Das Template wird in ein .tvtpl-Archiv gepackt (Hardware-Manifest + jede Festplatte zu qcow2 abgeflacht) und als neue VM-Template-Datei im gewählten Katalog abgelegt. NICs, CD-/DVD-Medien und cloud-init reisen nicht mit — die Format-Spec listet jede bewusste Auslassung auf.',
      exportName: 'Dateiname',
      exportNameHint: 'Leer = <template>-export-<n>',
      exportStorageDefault: 'Der Metadaten-Storage des Templates',
      importAction: 'Aus dem Katalog importieren',
      importTitle: 'Aus dem Katalog importieren',
      importHint: 'Eine VM-Template-Datei im Zustand ready des gewählten Katalogs wird zu einem Template des Inventars: Das Format der Datei (tvtpl, ova, ovf oder nacktes qcow2) entscheidet allein, wie sie importiert wird — Sie wählen nur die Datei.',
      importFile: 'Katalogdatei',
      importFileHint: 'Nur ready-Dateien werden importiert — eine mitten im Upload ist nicht importierbar',
      importNoFiles: 'Keine ready VM-Template-Datei in diesem Katalog — laden Sie zuerst eine hoch oder exportieren Sie eine'
    },
    templateDetail: {
      quickDeploy: 'QuickDeploy-Kompatibilität',
      quickDeployNone: 'Nicht erklärt',
      quickDeployHint: 'Erklären Sie sie nur, wenn das Golden-Image cloud-init (Linux) oder cloudbase-init nach sysprep /generalize (Windows) enthält: Die Plattform vertraut der Erklärung und schaut nie in den Guest hinein.',
      notFound: 'Template nicht gefunden',
      frozen: 'Die Hardware-Konfiguration ist eingefroren: Konvertieren Sie das Template zurück in eine VM, um sie zu ändern. Name, Notizen und Tags bleiben bearbeitbar.',
      storage: 'Storage',
      size: 'Größe',
      configTitle: 'Konfiguration (eingefroren)',
      usbClasses: 'Geforderte USB-Klassen',
      gpuClasses: 'Geforderte GPU-Klassen'
    },
    sharedDisksTab: {
      title: 'Gemeinsame Datenträger',
      sharing: 'Freigabe',
      sharingNone: 'Einzelner Attach',
      sharingMultiwriter: 'Gemeinsames Schreiben (multiwriter)',
      sharingReadonly: 'Gemeinsam nur lesend',
      usedBy: 'In Benutzung von',
      attachedTo: 'Angehängt an',
      notAttached: 'An keine VM angehängt',
      changeSharing: 'Freigabemodus ändern',
      changeSharingTitle: 'Freigabemodus',
      changeSharingLocked: 'Der Modus lässt sich nur ändern, solange keine VM den Datenträger nutzt',
      sharingChanged: 'Freigabemodus aktualisiert.',
      lun: 'Ganze LUN',
      lunNumber: 'LUN / Namespace',
      lunWwn: 'WWN',
      lunSerial: 'Seriennummer',
      antiAffinityWarning: 'Zwei oder mehr Mitglieder laufen ohne Anti-Affinitätsregel auf demselben Knoten: ein Knotenausfall reißt alle mit',
      antiAffinityCreate: 'Regel anlegen',
      createSourceLun: 'Eine ganze LUN des Targets übernehmen',
      createLunNumber: 'LUN-Nummer (Namespace-ID bei NVMe)',
      createLunHint: 'Es wird nichts zugewiesen: die Größe wird beim Übernehmen vom Gerät gelesen',
      noPr: 'In dieser Version gibt es keine SCSI-3 Persistent Reservations: ein Windows Failover Cluster mit klassischer Shared Disk ist nicht validiert; Cluster, die über das Netz koordinieren (GFS2/OCFS2, RHEL HA, Shared-Disk-Datenbanken), schon'
    },
    unusedDisksTab: {
      title: 'Unbenutzte Festplatten',
      attach: 'An eine VM anhängen',
      attachTitle: 'An eine VM anhängen',
      vm: 'Virtuelle Maschine',
      noVms: 'Keine VM verfügbar',
      noSlots: 'Kein freier Slot auf dieser VM',
      create: 'Festplatte erstellen',
      createTitle: 'Festplatte erstellen',
      createSourceBlank: 'Leere Festplatte',
      createSourceImage: 'Aus einem Katalog-Image',
      createImage: 'Image',
      createImageEmpty: 'Kein bereites VM-Vorlagen-Image in den sichtbaren Katalogen',
      createSizeFromImageHint: 'Vorbelegt mit der virtuellen Größe des Images — sie kann nur wachsen',
      convert: 'In ein VM-Template konvertieren…',
      convertOnlyQcow2: 'Nur qcow2-Festplatten lassen sich konvertieren — raw ist kein registrierbares Template-Format',
      convertTitle: 'In ein VM-Template konvertieren',
      convertSubmit: 'Konvertieren (zerstört die Festplatte)',
      convertError: 'Die Konvertierung konnte nicht starten',
      convertWarning: 'DESTRUKTIV: Die Festplatte wird zu einer VM-Template-Datei im gewählten Katalog — derselbe Storage, null kopierte Bytes — und HÖRT AUF, als Festplatte ZU EXISTIEREN. Zurück geht es nur, indem eine neue Festplatte aus dem Template erstellt wird.',
      convertNameHint: 'Der Name der Katalogdatei — Default ist der der Festplatte',
      convertConfirm: 'Ich habe verstanden: Die Festplatte wird zerstört',
      convertStarted: 'Konvertierung gestartet — das Template erscheint im Katalog, wenn der Task abschließt.',
      storageLockHint: 'Der Storage ändert sich nur über die Aktion Verschieben',
      source: 'Herkunft',
      sourceClone: 'Klon einer anderen Festplatte',
      sourceCloneLinked: 'Linked Clone einer anderen Festplatte',
      sourceImage: 'Aus einem Image erstellt',
      sourceBlank: 'Leer erstellt',
      allocated: 'Allokiert / virtuelle Größe',
      observedAt: 'Beobachtet am',
      snapshots: 'Snapshots',
      snapshotsEmpty: 'Keine Snapshots'
    },
    phase: {
      defined: 'Nie eingeschaltet',
      starting: 'Startet',
      running: 'Läuft',
      stopping: 'Wird gestoppt',
      stopped: 'Ausgeschaltet',
      paused: 'Pausiert',
      failed: 'Fehlgeschlagen',
      deleting: 'Wird gelöscht'
    },
    stopCause: {
      'api': 'Von TVirt gestoppt (Aktion oder API)',
      'guest-shutdown': 'Shutdown vom Guest-Betriebssystem eingeleitet',
      'crash': 'Crash des Guests',
      'qemu-exit': 'Der QEMU-Prozess hat sich unerwartet beendet',
      'host-reboot': 'Der Knoten wurde neu gestartet',
      'migrated': 'Auf einen anderen Knoten migriert',
      'fenced': 'Vom HA-Fencing beendet (zurückgekehrter Knoten)'
    },
    detail: {
      notFound: 'Virtuelle Maschine nicht gefunden',
      details: 'Details',
      id: 'ID',
      scope: 'Scope',
      profile: 'Hardware-Profil',
      firmware: 'Firmware',
      firmwareFile: 'UEFI-Firmware-Version',
      firmwareUpdate: 'Update verfügbar',
      firmwareUpdateHint: 'Die Plattform liefert eine neuere UEFI-Firmware. Das Update erfolgt nie automatisch: es wird bei ausgeschalteter VM angewendet, wenn Sie es entscheiden.',
      arch: 'Architektur',
      node: 'Knoten',
      bootOrder: 'Boot-Reihenfolge',
      agent: 'Agent-Status',
      agentConnected: 'Verbunden',
      agentNotConnected: 'Nicht verbunden',
      protected: 'Geschützt',
      linkedClones: 'Verknüpfte Klone',
      restartPolicy: 'Neustart-Richtlinie',
      preferredNode: 'Bevorzugter Knoten',
      noPreference: 'Keine Präferenz (automatisches Placement)',
      preferNodes: 'Bevorzugte Knoten-Tags',
      requireNodes: 'Erforderliche Knoten-Tags',
      noPlacementTags: 'Keine',
      placementTag: 'Tag',
      placementValue: 'Wert',
      placementAddTag: 'Tag hinzufügen',
      proximityHa: 'HA von TVirt Proximity',
      proximityHaRestarts: 'HA-Neustarts',
      proximityHaGaveUp: 'Crash-Loop — HA hat aufgegeben',
      failoverProtection: 'Schutz im degradierten Cluster',
      protectionProtected: 'Geschützt',
      protectionExpendable: 'Im degradierten Zustand opferbar',
      protectionInherit: 'Erben',
      lastStop: 'Letzter Stopp',
      yes: 'Ja',
      no: 'Nein',
      tabOverview: 'Übersicht',
      tabSnapshots: 'Snapshots',
      tabBackups: 'Sicherungen',
      hardware: 'Hardware',
      name: 'Name',
      hwSystem: 'System',
      hwCpu: 'CPU',
      hwMemory: 'Arbeitsspeicher',
      hwBoot: 'Start',
      hwIdentity: 'Identität',
      hwCluster: 'Cluster und Agent',
      cpuTopology: 'CPU-Topologie',
      cpuModel: 'CPU-Modell',
      cpuLimit: 'CPU-Limit',
      cpuWeight: 'CPU-Gewicht',
      cpuNested: "Verschachtelte Virtualisierung",
      cpuNestedHint: "Stellt dem Gast vmx/svm bereit (nur mit CPU-Modell host). Bei laufender VM gilt die Änderung ab dem nächsten Power-Cycle (PendingRestart); die Platzierung lässt nur Knoten mit aktiviertem Nested zu.",
      unlimited: 'Unbegrenzt',
      memory: 'Arbeitsspeicher',
      balloon: 'Balloon',
      hugePages: 'Riesenseiten',
      hugePagesTradeoff: 'Weniger Adressübersetzungsarbeit und Speicher, der nie auf die Platte ausgelagert wird; dafür bleibt die Reservierung am Knoten gebunden, solange die VM läuft, der Speicher wird nicht mehr dedupliziert, und der Start schlägt fehl, wenn der Knoten zu wenige freie Seiten hat.',
      disks: 'Festplatten',
      cdroms: 'CD-/DVD-Laufwerke',
      nics: 'Netzwerkschnittstellen',
      slot: 'Slot',
      disk: 'Festplatte',
      encrypted: 'Verschlüsselt',
      image: 'Image',
      emptyDrive: 'Leeres Laufwerk',
      emptyOption: '(leer)',
      network: 'Netzwerk',
      mac: 'MAC',
      connected: 'Verbunden',
      unplugged: 'Getrennt',
      noDevices: 'Keine',
      screenshot: 'Screenshot',
      capturedAt: 'Aufgenommen um',
      noCapture: 'Noch keine Aufnahme',
      snapshotName: 'Name',
      snapshotCreated: 'Erstellt',
      snapshotMemory: 'Arbeitsspeicher enthalten',
      noSnapshots: 'Keine Snapshots',
      pendingRestart: 'Änderungen ausstehend: Sie werden beim nächsten Power-Cycle angewendet.',
      applied: 'angewendet',
      appliedHint: 'Die VM läuft gerade mit diesem Wert — der konfigurierte gilt ab dem nächsten Power-Cycle.',
      actionError: 'Aktion fehlgeschlagen',
      actionStillRunning: 'Die Aktion läuft noch — das Ergebnis ist noch nicht bekannt',
      tabConsole: 'Konsole',
      consoleConnect: 'Verbinden',
      consoleDisconnect: 'Trennen',
      consoleConnecting: 'Verbindung…',
      consoleReconnecting: 'Verbindung…',
      consoleUnavailable: 'Die Konsole ist verfügbar, während die VM läuft oder pausiert ist.',
      consoleError: 'Konsolenverbindung fehlgeschlagen',
      consoleTaken: 'Konsolensitzung von {user} übernommen',
      consoleReconnect: 'Neu verbinden',
      consoleCtrlAltDel: 'Strg+Alt+Entf',
      consoleHold: '{key} gedrückt halten',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Im neuen Tab als Vollbild öffnen',
      consoleLoadFailed: 'VM nicht gefunden oder unzureichende Berechtigungen',
      consoleClose: 'Schließen',
      tabStats: 'Statistiken',
      tabTasks: 'Tasks',
      tabLogs: 'Logs',
      statsCpu: 'CPU',
      statsMemory: 'Arbeitsspeicher',
      statsDisk: 'Festplatten-I/O',
      statsRange: 'Zeitraum',
      statsNoData: 'Keine Daten im gewählten Zeitraum — die Statistiken werden erfasst, während die VM läuft.',
      statsError: 'Die Statistiken konnten nicht geladen werden',
      cpuUsage: 'Auslastung',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Benutzt',
      memGuestAvailable: 'Verfügbar (Guest)',
      schema: 'Schema',
      consoleProtocol: 'Konsole',
      agentEnabled: 'Guest Agent',
      metadataStorage: 'Metadaten-Storage',
      startupOnBoot: 'Start beim Boot',
      startupOrder: 'Startreihenfolge',
      startupDelay: 'Startverzögerung',
      seconds: 's',
      enabled: 'Aktiviert',
      disabled: 'Deaktiviert'
    },
    actionsAvailable: 'Verfügbare Aktionen',
    actions: {
      start: 'Starten',
      stop: 'Stoppen',
      pause: 'Pausieren',
      resume: 'Fortsetzen',
      reset: 'Reset',
      migrate: 'Migrieren',
      clone: 'Klonen',
      moveStorage: 'Auf Storage verschieben…',
      moveScope: 'In Scope verschieben…',
      openConsole: 'Konsole öffnen',
      forceStop: 'Ausschalten erzwingen',
      markTemplate: 'Als Template markieren',
      unmarkTemplate: 'Zurück in VM konvertieren',
      error: 'Die Aktion konnte nicht ausgeführt werden'
    },
    cordon: {
      confirmTitle: 'Der Knoten ist in Wartung',
      confirmHint:
        'Der Kordon lässt sich nicht senken, solange der Cluster-Store nicht erreichbar ist. Mit der Bestätigung erklären Sie, dass Sie das wissen: Die VM startet dort trotzdem, und die Zustimmung wird am Task festgehalten.',
      confirm: 'Trotzdem starten'
    },
    markTemplate: {
      confirmTitle: '{name} als Template markieren?',
      confirmBody: 'Die Konfiguration friert ein und die VM kann nicht mehr eingeschaltet werden — nur noch geklont oder zurückverwandelt. Name, Notizen und Tags bleiben bearbeitbar.',
      confirm: 'Als Template markieren',
      moved: '{name} ist jetzt ein Template — es ist in den Templates-Tab umgezogen.'
    },
    unmarkTemplate: {
      confirmTitle: '{name} zurück in eine VM konvertieren?',
      confirmBody: 'Das Template wird wieder eine gewöhnliche VM: bearbeitbar und startbar (der nächste Start platziert sie auf einem Knoten).',
      confirm: 'Zurück in VM konvertieren',
      moved: '{name} ist wieder eine virtuelle Maschine — sie ist in den Tab Virtuelle Maschinen umgezogen.'
    },

    // Round #123: riferimento a nodo per TAG (selettore #106) nei dialog
    // di start e migrazione — anteprima dell'insieme risolto inclusa.
    nodeByTag: {
      label: 'Per Knoten-Tag',
      hint: 'tag=Wert, kommagetrennt (UND-verknüpft): der Decider wählt unter den passenden Knoten',
      invalid: 'Ungültiges Format — tag=Wert verwenden, kommagetrennt',
      resolved: 'Passende Mitglieder: {nodes}'
    },
    migrate: {
      title: 'Live Migration',
      submit: 'Migrieren',
      target: 'Zielknoten',
      auto: 'Automatisch (Proximity)',
      hint: 'Die VM zieht ohne Power-Cycle um. Jeder Storage, den sie berührt, muss geteilt sein; eine pausierte VM migriert pausiert.',
      error: 'Die Migration wurde abgelehnt'
    },
    moveStorage: {
      title: 'Auf Storage verschieben',
      submit: 'Verschieben',
      target: 'Ziel-Storage',
      noTargets: 'Kein Storage nimmt Festplatten an',
      hint: 'Alle Festplatten der ausgeschalteten VM reisen auf den gewählten Storage, eine nach der anderen, unter Beibehaltung ihrer Id — bereits dort liegende werden übersprungen. Der Fortschritt lebt auf der Task-Seite.',
      error: 'Die Storage-Verschiebung wurde abgelehnt'
    },
    moveScope: {
      title: 'In Scope verschieben',
      submit: 'Verschieben',
      target: 'Ziel-Scope',
      hint: 'Die VM wechselt den Scope sofort — Id und Festplatten bleiben, ihre owned-Festplatten folgen ihr, und sie kann eingeschaltet bleiben. Heute lebt sie in {scope}. Wer sie sieht, ändert sich mit dem Scope.',
      error: 'Die Scope-Verschiebung wurde abgelehnt'
    },
    start: {
      title: 'VM starten',
      submit: 'Starten',
      target: 'Zielknoten',
      auto: 'Automatisch (empfohlen)',
      recommended: 'empfohlen',
      hint: 'Wählen Sie einen Zielknoten oder lassen Sie Proximity unter den gültigen Kandidaten entscheiden. Knoten, die sie nicht beherbergen können, sind mit dem Grund deaktiviert.',
      error: 'Die VM konnte nicht gestartet werden'
    },
    console: {
      media: 'CD-/DVD-Laufwerke',
      mediaGuestToolsHint: 'Enthält die TVirt Guest Tools — hier können Sie sie auswerfen oder das Laufwerk entfernen',
      slotOpsDeferred: 'Auf diesem Profil gelten Hinzufügen und Entfernen von Laufwerken ab dem nächsten Power-Cycle (Medienwechsel sind sofort).',
      mountGuestTools: 'TVirt Guest Tools mounten',
      ejectGuestTools: 'TVirt Guest Tools auswerfen',
      bootOrder: 'Boot-Reihenfolge',
      bootOrderHint: 'Die neue Reihenfolge wird sofort gespeichert und gilt ab dem nächsten Power-Cycle — die Konsolensitzung bleibt verbunden.'
    },
    snapshots: {
      create: 'Snapshot erstellen',
      createTitle: 'Einen Snapshot erstellen',
      createSubmit: 'Erstellen',
      name: 'Name',
      nameHint: 'Buchstaben, Ziffern, Punkt, Bindestrich, Unterstrich.',
      consistencyHint: 'Die Konsistenz ist automatisch: Der Guest Agent friert die Filesystems ein, wenn er antwortet; andernfalls pausiert die VM rund um den Snapshot für einen Augenblick.',
      memory: 'Arbeitsspeicher einschließen',
      memoryHint: 'Erfasst den lebenden RAM: Die Wiederherstellung setzt die VM laufend fort. Erfordert alle Festplatten als qcow2.',
      currentChip: 'Sie sind hier',
      revert: 'Wiederherstellen',
      revertTitle: '{name} wiederherstellen?',
      revertBody: 'Die Festplatten kehren zum Stand des Snapshots zurück; alles danach geht verloren. Ein Nur-Festplatten-Snapshot verlangt die VM ausgeschaltet.',
      delete: 'Löschen',
      deleteTitle: 'Snapshot {name} löschen?',
      deleteBody: 'Der Wiederherstellungspunkt verschwindet; der Inhalt der Festplatten bleibt unangetastet.',
      deleteMergeHint: 'Sein Delta wird in {children} zusammengeführt: jeder spätere Wiederherstellungspunkt bleibt gültig.',
      deleteDuplication: 'Ich akzeptiere die Duplizierung',
      deleteDuplicationHint: 'Das Delta wird in jeden der {count} Leser kopiert (die Kind-Snapshots und, falls dies der aktuelle ist, den aktiven Kopf): der belegte Speicher kann wachsen statt zu schrumpfen.',
      error: 'Die Snapshot-Operation wurde abgelehnt'
    },
    clone: {
      title: 'VM klonen',
      submit: 'Klonen',
      name: 'Name der Kopie',
      storage: 'Ziel-Storage der Festplatten',
      sameStorage: 'Derselbe wie die Quelle',
      full: 'Vollständige Kopie',
      fullHint: 'Kopiert jedes Byte und trennt das Band zu den Quellfestplatten. Der Default ist ein Linked Clone: sofort, aber an die Quelle gekettet (nur qcow2).',
      hint: 'Der Klon behält Konfiguration und Firmware der Quelle; MAC-Adressen und TPM-Identität sind neu.',
      markAs: 'Art des Klons',
      markAsInheritVm: 'Wie die Quelle (VM)',
      markAsInheritTemplate: 'Wie die Quelle (Template)',
      markAsVm: 'Virtuelle Maschine',
      markAsTemplate: 'Template',
      markAsHintVm: 'Wählen Sie Template, um die Kopie in einem Schritt zu befördern.',
      markAsHintTemplate: 'Wählen Sie Virtuelle Maschine, um in einem Schritt aus diesem Template zu deployen.',
      error: 'Das Klonen wurde abgelehnt'
    },
    bulk: {
      selected: 'ausgewählt',
      deleteTitle: {
        one: '{count} ausgewählte VM löschen?',
        other: '{count} ausgewählte VMs löschen?'
      },
      deleteBody: 'Jede VM durchläuft dieselben Wächter wie ein einzelnes Löschen; Ablehnungen werden je Element gemeldet.',
      done: 'akzeptiert',
      refused: 'abgelehnt'
    },
    delete: {
      button: 'Löschen',
      confirmTitle: '{name} löschen?',
      confirmBody: 'Die virtuelle Maschine und die Festplatten in ihrem Besitz werden gelöscht. Das lässt sich nicht rückgängig machen.',
      keepDisks: 'Festplatten behalten',
      keepDisksHint: 'Die mit der VM erstellten Festplatten bleiben als eigenständige Festplatten in ihrem Storage.',
      confirm: 'Löschen',
      cancel: 'Abbrechen',
      error: 'Löschen fehlgeschlagen',
      blockedPhase: 'Stoppen Sie zuerst die VM',
      blockedProtected: 'Die VM ist geschützt — entfernen Sie zuerst den Schutz',
      blockedDeleting: 'Löschung bereits im Gang'
    },
    logs: {
      title: 'Logs',
      subtitle: 'Strukturierte Log-Frames der Tasks, die diese VM berühren',
      when: 'Wann',
      task: 'Task',
      level: 'Stufe',
      message: 'Nachricht',
      empty: 'Noch keine Logs',
      loadError: 'Die Logs konnten nicht geladen werden — ist das TVirt-Backend erreichbar?'
    },
    stop: {
      title: 'Virtuelle Maschine stoppen',
      modeGraceful: 'Herunterfahren (graceful)',
      modeGracefulHint: 'Das Guest-Betriebssystem wird gebeten, sich sauber herunterzufahren (ACPI); ignoriert es die Bitte, folgt nach dem Timeout das erzwungene Ausschalten.',
      modeForced: 'Erzwungenes Ausschalten',
      modeForcedHint: 'Kappt sofort den Strom — wie den Stecker zu ziehen.',
      timeout: 'Fallback-Timeout (Sekunden)',
      timeoutHint: 'Wie lange dem Guest gewährt wird, bevor das Ausschalten erzwungen wird'
    },
    createFromScratch: 'Von Grund auf',
    createFromTemplate: 'Aus Template',
    createQuickDeploy: 'TVirt QuickDeploy',
    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Deploy ausführen',
      error: 'Deploy fehlgeschlagen',
      compatNote: 'QuickDeploy verlangt ein QuickDeploy-kompatibles Template: Die Plattform passt den Guest (Netzwerk, Domäne, Aktivierung) beim ersten Start an.',
      template: 'Template',
      noTemplates: 'Noch kein Template erklärt QuickDeploy-Kompatibilität — erklären Sie sie im Templates-Tab (Linux mit cloud-init, Windows mit cloudbase-init nach sysprep)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Hostname',
      hostnameHint: 'Hostname oder FQDN; leer = der Name der VM (Windows: höchstens 15 Zeichen)',
      ip: 'IP-Adresse',
      ipHint: 'Host und Präfix, z. B. 192.168.122.101/24; leer = DHCP',
      gateway: 'Gateway',
      dns: 'DNS-Server',
      dnsHint: 'Bis zu drei, durch Komma getrennt',
      count: 'Instanzen',
      countHint: 'Mehr als eine: benannt <name>-1…-N, nur DHCP',
      user: 'Benutzer',
      userHint: 'Leer = der Standardbenutzer des Images (Linux) oder Administrator (Windows)',
      password: 'Passwort',
      passwordHint: 'Wird in die generierte user-data geschrieben, die die Plattform danach als geheim erklärt: niemand liest sie erneut',
      sshKeys: 'Öffentliche SSH-Schlüssel',
      sshKeysHint: 'Einer pro Zeile (ssh-ed25519 AAAA… Kommentar)',
      productKey: 'Windows-Product-Key',
      kmsServer: 'KMS-Server',
      kmsHint: 'Host oder Host:Port — verlangt einen Product Key (einen KMS-Client-Key)',
      adDomain: 'Active-Directory-Domäne joinen',
      adDomainHint: 'Leer = kein Domänen-Join',
      adUser: 'Join-Konto',
      adPassword: 'Passwort des Join-Kontos',
      adOu: 'Ziel-OU (optional)',
      advanced: 'Erweitert: rohe Dokumente',
      userData: 'user-data (roh)',
      userDataHint: 'Übergeht die generierte user-data: Benutzer, Passwort, Schlüssel und die Windows-Felder oben müssen leer bleiben',
      networkConfig: 'network-config (roh)',
      networkConfigHint: 'Übergeht das generierte Netzwerk: IP, Gateway und DNS oben müssen leer bleiben',
      secret: 'Die rohe user-data als geheim behandeln',
      secretHint: 'Als geheim markiert, wird sie von der API niemandem mehr zurückgegeben und reist im Checkpoint mit der Masterpass versiegelt',
      startNow: 'Sofort starten',
      startNowHint: 'Jede Instanz startet, sobald sie definiert ist; der Seed entsteht bei diesem Start'
    },
    create: {
      nicAttachmentNetwork: 'Logisches Netz (Fabric)',
      nicNetwork: 'Logisches Netz',
      nicNetworkHint: 'Der EMPFOHLENE Weg (F3): die vNIC realisiert sich auf der ABGELEITETEN Bridge des bedienenden Knotens — die Bridge entsteht beim expliziten Fabric-Apply, und ein Start auf einem Knoten, der sie noch nicht trägt, lehnt sprechend ab. Geht die letzte Referenz der Flotte, fällt die Bridge beim nächsten Apply heraus.',
      button: 'VM erstellen',
      title: 'Virtuelle Maschine erstellen',
      dialogTitle: 'Virtuelle Maschine erstellen',
      stepGeneral: 'Allgemein',
      stepGeneralHint: 'Name und Profil',
      stepCompute: 'CPU und RAM',
      stepComputeHint: 'Topologie und Dimensionierung',
      stepDisks: 'Festplatten',
      stepDisksHint: 'Erstellen oder anhängen',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Laufwerke und Medien',
      stepNetwork: 'Netzwerk',
      stepNetworkHint: 'NICs: Trunk oder Bridge',
      stepSummary: 'Zusammenfassung',
      stepSummaryHint: 'Prüfen und erstellen',
      name: 'Name',
      nameHint: 'Kleinbuchstaben, Ziffern und Bindestriche (DNS-1123)',
      nextButton: 'Weiter',
      prevButton: 'Zurück',
      submitButton: 'Erstellen',
      creating: 'Wird erstellt…',
      sockets: 'Sockets',
      cores: 'Kerne je Socket',
      threads: 'Threads je Kern',
      totalVcpus: 'vCPU gesamt',
      memoryGib: 'Arbeitsspeicher (GiB)',
      cpuModelHint: "'host' exponiert die CPU des Hosts",
      cpuLimitHint: 'Obergrenze in Host-Kernen — leer = unbegrenzt',
      cpuNestedHint: "Stellt dem Gast vmx/svm bereit, damit er einen eigenen Hypervisor ausführen kann — erfordert das CPU-Modell host und einen Knoten mit aktiviertem Nested",
      newDisk: 'Neue Festplatte',
      attachDisk: 'Vorhandene Festplatte anhängen',
      diskStorage: 'Storage',
      diskSize: 'Größe (GiB)',
      diskSelect: 'Festplatte',
      addDisk: 'Festplatte hinzufügen',
      addCdrom: 'CD-/DVD-Laufwerk hinzufügen',
      addNic: 'Netzwerkschnittstelle hinzufügen',
      remove: 'Entfernen',
      slotLimit: 'Slot-Limit erreicht',
      cdromImage: 'Image (leeres Laufwerk, wenn keins)',
      nicAttachment: 'Anbindung',
      nicAttachmentTrunk: 'Overlay-Trunk',
      nicAttachmentBridge: 'Host-Bridge',
      nicUntagged: 'Untagged-Overlay',
      nicUntaggedNone: 'Keins (nur tagged)',
      nicTrunkHint: 'Mindestens eine Seite: ein untagged Overlay und/oder tagged VLAN-Mappings — die VM kann nur auf den Hosts laufen, die von jedem referenzierten Overlay deklariert sind',
      nicTaggedVlan: 'VLAN-ID',
      nicTaggedOverlay: 'Overlay-Netzwerk',
      addTagged: 'Tagged VLAN hinzufügen',
      nicBridge: 'Name der Host-Bridge',
      nicBridgeHint: 'NM-Host-Bridge nach Name — die VM kann nur auf Servern laufen, deren Host-Netzwerk diese Bridge deklariert',
      nicMac: 'MAC (auto, wenn leer)',
      noDisksHint: 'Keine Festplatten: Die VM wird nur die CD-/DVD-Laufwerke haben, die Sie hinzufügen.',
      noCdromsHint: 'Keine CD-/DVD-Laufwerke: Fügen Sie eines hinzu, um von einem ISO-Image zu starten.',
      mountGuestTools: 'TVirt Guest Tools beim ersten Start mounten',
      mountGuestToolsHint: 'Legt die ISO mit den virtio-Treibern und dem Guest Agent in ein leeres CD-Laufwerk (bei Bedarf hinzugefügt) — der Windows-Installer braucht sie, um seine Festplatten zu sehen.',
      noNicsHint: 'Keine Netzwerkschnittstellen: Die VM startet ohne Konnektivität.',
      taggedMappings: 'Tagged-VLAN-Mappings',
      summaryDevices: 'Geräte',
      bootOrderTitle: 'Boot-Reihenfolge',
      bootOrderHint: 'Zum Umordnen ziehen — das erste bootfähige Gerät gewinnt; NICs booten PXE',
      bootOrderUp: 'Nach oben',
      bootOrderDown: 'Nach unten',
      createError: 'Erstellung fehlgeschlagen'
    },
    edit: {
      button: 'Bearbeiten',
      title: 'Virtuelle Maschine bearbeiten',
      cancel: 'Abbrechen',
      save: 'Speichern',
      error: 'Änderung fehlgeschlagen',
      modelStoppedOnly: 'Nur bei ausgeschalteter VM änderbar',
      firmwareStoppedOnly: 'Firmware nur bei ausgeschalteter VM änderbar — der nächste Start bootet die neue Firmware, die UEFI-Variablen bleiben',
      hugePagesStoppedOnly: 'Nur bei gestoppter VM änderbar — beim nächsten Start entsteht der Speicher auf der neuen Unterlage',
      runningHint: 'Änderungen gelten ab dem nächsten Power-Cycle',
      sectionCpu: 'CPU',
      sectionMemory: 'Arbeitsspeicher',
      sectionPolicy: 'Richtlinien'
    },
    devices: {
      networkChip: 'Fabric-Netz',
      title: 'Geräte',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'USB-Gerät hinzufügen',
      addUsbTitle: 'Eine USB-Geräteklasse anfordern',
      usbClassHint:
        'Die VM fordert eine KLASSE von USB-Geräten an (einen Wert eines usb-device-Tags), nie ein punktuelles Gerät: Beim Start wird das konkrete freie Gerät auf dem gewählten Knoten ausgewählt und reserviert. Taggen Sie die registrierten Geräte unter Cluster › USB- und PCIe-Ressourcen.',
      usbTag: 'Tag (usb-device)',
      usbValue: 'Wert der Klasse',
      noUsbTags: 'Noch kein usb-device-Tag — legen Sie einen an und taggen Sie die registrierten Geräte unter Cluster › USB- und PCIe-Ressourcen.',
      noUsbValues: 'Dieser Tag hat noch keine deklarierten Werte.',
      usbEmpty: 'Keine USB-Anforderung — fügen Sie eine Klasse hinzu, um beim Start ein Gerät durchzureichen.',
      usbClassChip: 'Klasse',
      usbPortChip: 'Port',
      usbUnclaimed: 'Kein Gerät reserviert — wird beim Start der VM aufgelöst.',
      addGpu: 'GPU hinzufügen',
      addGpuTitle: 'Eine GPU-Klasse anfordern',
      gpuClassHint:
        'Die VM fordert eine KLASSE von GPUs an (einen Wert eines gpu-device-Tags), nie eine punktuelle Karte: Beim Start wird die konkrete freie Karte auf dem gewählten Knoten ausgewählt und reserviert, und ihre GESAMTE IOMMU-Gruppe wird ZUSAMMEN durchgereicht. Taggen Sie die registrierten GPUs unter Cluster › USB- und PCIe-Ressourcen.',
      gpuTag: 'Tag (gpu-device)',
      gpuValue: 'Wert der Klasse',
      noGpuTags: 'Noch kein gpu-device-Tag — legen Sie einen an und taggen Sie die registrierten GPUs unter Cluster › USB- und PCIe-Ressourcen.',
      noGpuValues: 'Dieser Tag hat noch keine deklarierten Werte.',
      gpuEmpty: 'Keine GPU-Anforderung — fügen Sie eine Klasse hinzu, um beim Start eine Karte durchzureichen.',
      gpuClassChip: 'Klasse',
      gpuGroupChip: 'IOMMU-Gruppe ×',
      gpuUnclaimed: 'Keine Karte reserviert — wird beim Start der VM aufgelöst.',
      gpuPowerCycle: 'Kein GPU-Hotplug — Änderungen gelten ab dem nächsten Power-Cycle (PendingRestart)',
      actions: 'Aktionen',
      attachDisk: 'Festplatte hinzufügen',
      attachDiskTitle: 'Eine Festplatte hinzufügen',
      attach: 'Anhängen',
      noFreeDisks: 'Keine unbenutzte Festplatte — erstellen Sie eine unter Virtuelle Maschinen › Unbenutzte Festplatten.',
      addCdrom: 'Laufwerk hinzufügen',
      addCdromTitle: 'Ein CD-/DVD-Laufwerk hinzufügen',
      editCdromTitle: 'CD-/DVD-Image wechseln',
      changeMedia: 'CD-/DVD-Image wechseln',
      ejectMedium: 'Auswerfen',
      mountGuestTools: 'TVirt Guest Tools mounten',
      guestToolsMounted: 'TVirt Guest Tools gemountet',
      guestToolsClickMount: 'Legt die TVirt-Guest-Tools-ISO in das erste leere CD-/DVD-Laufwerk',
      guestToolsClickUnmount: 'Zum Auswerfen klicken — das Laufwerk bleibt, leer',
      guestToolsNoSlot: 'Kein leeres CD-/DVD-Laufwerk — fügen Sie ein Laufwerk hinzu (oder werfen Sie ein Medium aus), um die TVirt Guest Tools zu mounten',
      guestToolsSkew: 'Eingehängt v{pinned}; Knoten {node} liefert jetzt v{current}: auswerfen und neu einhängen, um zu aktualisieren',
      ejectGuestTools: 'TVirt Guest Tools auswerfen (das Laufwerk bleibt, leer)',
      guestToolsEjectConfirmTitle: 'TVirt Guest Tools auswerfen?',
      guestToolsEjectConfirmBody: 'Das Medium wird aus der eingeschalteten VM ausgeworfen — das CD-/DVD-Laufwerk bleibt, leer.',
      applyLive: 'Sofort anwenden (die VM läuft)',
      addNic: 'Schnittstelle hinzufügen',
      addNicTitle: 'Eine Netzwerkschnittstelle hinzufügen',
      editNicTitle: 'Netzwerkschnittstelle bearbeiten',
      bridgeChip: 'Bridge',
      cable: 'Virtuelles Kabel',
      plug: 'Virtuelles Kabel einstecken',
      unplug: 'Virtuelles Kabel abziehen',
      remove: 'Entfernen',
      removeTitle: '{device} entfernen?',
      removeBody: 'Bei eingeschalteter VM gilt die Änderung ab dem nächsten Power-Cycle. Festplatten und Images werden abgehängt, nie gelöscht.'
    }
  }
}
